import { Box, Typography } from '@mui/material';
import ExportPDF from './ExportPDF';
import { FridayTableHU, FridayTableDE, FridayTableUS, FridayWorkshopsHU } from './FridayTable';
import { SaturdayTableHU, SaturdayTableDE, SaturdayTableUS } from './SaturdayTable';

export function ProgramHU() {
  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#f0f0f0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        color: '#333',
      }}>
      <Typography variant="h3" sx={{ fontWeight: 'bold', marginBottom: '30px', marginTop: '30px', color: '#333' }}>
        Programok
      </Typography>

      {/* Table Section */}
      <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: '20px' }}>
        2025 május 9. péntek
      </Typography>

      <div id="fridayTable">
        <FridayTableHU />
      </div>

      <div id="fridayWorkshops">
        <FridayWorkshopsHU />
      </div>

      <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: '20px' }}>
        2025 május 10. szombat
      </Typography>

      <div id="saturdayTable">
        <SaturdayTableHU />
      </div>

      {/* Download PDF */}
      <ExportPDF />

    </Box>
  )
}

export function ProgramDE() {
  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#f0f0f0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        color: '#333',
      }}>
      <Typography variant="h3" sx={{ fontWeight: 'bold', marginBottom: '30px', marginTop: '30px', color: '#333' }}>
        Programme
      </Typography>

      {/* Table Section */}
      <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: '20px' }}>
        9 Mai 2025 - Freitag
      </Typography>

      <div id="fridayTable">
        <FridayTableDE />
      </div>

      <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: '20px' }}>
        10 Mai 2025 - Samstag
      </Typography>

      <div id="saturdayTable">
        <SaturdayTableDE />
      </div>

      {/* Download PDF */}
      <ExportPDF />

    </Box>
  )
}

export function ProgramUS() {
  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#f0f0f0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        color: '#333',
      }}>
      <Typography variant="h3" sx={{ fontWeight: 'bold', marginBottom: '30px', marginTop: '30px', color: '#333' }}>
        Programs
      </Typography>

      {/* Table Section */}
      <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: '20px' }}>
        9 May 2025 - Friday
      </Typography>

      <div id="fridayTable">
        <FridayTableUS />
      </div>

      <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: '20px' }}>
        10 May 2025 - Saturday
      </Typography>

      <div id="saturdayTable">
        <SaturdayTableUS />
      </div>

      {/* Download PDF */}
      <ExportPDF />

    </Box>
  )
}